import { FC, ReactNode } from "react";
import { Grid } from '@mui/material';
import Footer from "@shared-web/components/Footer";

type AuthLayoutProps = {
  children: ReactNode;
}
const AuthLayout: FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Grid
      container
      height='100vh'
      width='100%'
      textAlign={"center"}
    >
      <Grid item xs={12}>
        {children}
      </Grid>
      <Grid item xs={12} display={'flex'} flexDirection={'column-reverse'}>
        {/* <Footer /> */}
      </Grid>
    </Grid>
  )
};

export default AuthLayout;
